// @ts-nocheck -- legacy migrated file; pending full TS cleanup. CKEditor Command
// subclasses pull in generic model types that don't usefully constrain this
// integration — same convention as CaseNest.UI's ckeditor plugins.
import { Command } from "ckeditor5";

export default class PlaceholderCommand extends Command {
  execute(placeholder) {
    const editor = this.editor;
    const selection = editor.model.document.selection;

    editor.model.change((writer) => {
      const placeholderElement = writer.createElement("placeholder", {
        ...Object.fromEntries(selection.getAttributes()),
        placeholder: placeholder,
      });

      editor.model.insertContent(placeholderElement);

      writer.setSelection(placeholderElement, "on");
    });
  }

  refresh() {
    const model = this.editor.model;
    const selection = model.document.selection;

    const isAllowed = model.schema.checkChild(
      selection.focus.parent,
      "placeholder"
    );

    this.isEnabled = isAllowed;
  }
}
